import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var MenusFilled = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M3.04711 2.5L2.51 10.0114C2.36323 12.0715 3.84905 13.8429 5.83357 14.1227V16.6667H3.33357V18.3333H10.0002V16.6667H7.50024V14.1227C9.48476 13.8429 10.9706 12.0715 10.8238 10.0114L10.2867 2.5H3.04711ZM13.3336 2.5V8.33333H12.3749L12.4856 9.89095C12.5248 10.436 12.4778 10.9805 12.3586 11.5055C12.6686 11.6014 12.9927 11.6667 13.3336 11.6667V18.3333H15.0002V11.6667C16.8411 11.6667 18.3336 10.1742 18.3336 8.33333V2.5H16.6669V8.33333H15.0002V2.5H13.3336Z",
    fill: fill
  }));
};
export { MenusFilled as default };
//# sourceMappingURL=MenusFilled.js.map
